import {IForm} from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'thirdParty',
      type: 'input',
      label: '所属第三方',
      placeholder: '请输入第三方名称',
      rules: {required: true, message: '第三方名称是必传的', trigger: 'blur'}
    },
    {
      field: 'thirdPartyAlias',
      type: 'input',
      label: '第三方别名',
      placeholder: '请输入第三方别名',
    },
    {
      field: 'channelName',
      type: 'input',
      label: '渠道名称',
      placeholder: '请输入渠道名称',
      rules: {required: true, message: '渠道名称是必传的', trigger: 'blur'}
    },
    {
      field: 'shortName',
      type: 'input',
      label: '渠道简称',
      placeholder: '请输入渠道简称',
      rules: {required: true, message: '渠道简称是必传的', trigger: 'blur'}
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
